import { BrowserRouter, Route, Switch } from "react-router-dom";
import Layout from "./components/layout/layout.jsx";
import Home from "./components/home/home.jsx";
import "./App.css";
import Contact from "./components/contact/contact.jsx";
import Announcements from "./components/announcements/announcements.jsx";
import Committee from "./components/committee/committee.jsx";
import Keynotes from "./components/keynotes/keynotes.jsx";
import Topics from "./components/topics/topics.jsx";
import About from "./components/about/about.jsx";
import CallForPapers from "./components/callforpaper/callforpaper.jsx";
import Register from "./components/register/register.jsx";
import Submit from "./components/submitthepaper/submit";
import Dates from "./components/dates/dates.jsx";
import Publications from "./components/publications/publications.jsx";
import Submission from "./components/submission/submission.jsx";

function App() {
	return (
		<BrowserRouter>
			<Layout>
				<Switch>
					<Route exact path="/" component={Home} />
					<Route exact path="/announcements" component={Announcements} />
					{/* <Route exact path="/about" component={About} /> */}
					<Route exact path="/committee" component={Committee} />
					<Route exact path="/keynotes" component={Keynotes} />
					<Route exact path="/callforpapers" component={CallForPapers} />
					<Route exact path="/tracks" component={Topics} />
					<Route exact path="/dates" component={Dates} />
					<Route exact path="/publications" component={Publications} />
					<Route exact path="/contact" component={Contact} />
					<Route exact path="/submission" component={Submission} />
					<Route exact path="/register" component={Register} />
					<Route exact path="/submit" component={Submit} />
				</Switch>
			</Layout>
		</BrowserRouter>
	);
}

export default App;
